import type { BadgeProps } from '@/components/ui/Badge'
import i18n from '@/i18n'
import type { LoanState } from './types'

type Tone = NonNullable<BadgeProps['tone']>

export const loanStateTone: Record<LoanState, Tone> = {
  active: 'info',
  overdue: 'danger',
  returned: 'neutral',
}
export const loanStateLabel: Record<LoanState, string> = {
  active: 'On loan',
  overdue: 'Overdue',
  returned: 'Returned',
}

/** Cents-precision check on decimal strings from the API. */
export function isPositiveAmount(value: string | null | undefined): boolean {
  return Math.round(Number(value ?? 0) * 100) > 0
}

export function todayIso(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function addDaysIso(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00`)
  d.setDate(d.getDate() + days)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/** "in 3 days", "today", "2 days ago" relative to today. */
export function relativeDue(iso: string): string {
  const ms = new Date(`${iso}T00:00:00`).getTime() - new Date(`${todayIso()}T00:00:00`).getTime()
  const days = Math.round(ms / 86_400_000)
  if (days === 0) return i18n.t('due today', { ns: 'library' })
  if (days === 1) return i18n.t('due tomorrow', { ns: 'library' })
  if (days > 1) return i18n.t('due in {{count}} days', { ns: 'library', count: days })
  return i18n.t('{{count}} days overdue', { ns: 'library', count: -days })
}
